export default "__VITE_ASSET__Bo$ZUTrO__"